import React, { useRef } from 'react';
import PageLoader from '../../../common/PageLoader';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useParams } from 'react-router-dom';
// import { AllPackages, GetOnePackage } from '../../../Redux/actions/HomeAction';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ImageGallery from 'react-image-gallery';
import $, { map } from 'jquery';
import { DETAIL_LIST } from '../../../../Redux/Actions/ActionType';
import 'react-image-gallery/styles/css/image-gallery.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-image-gallery/styles/css/image-gallery.css';
import moment from 'moment';
import { saveAItem, removeSavedItem, getSavedItems, addToRecentlyViewed } from '../../../../Redux/Actions/UserAction';
import { findSavedItemId } from '../../../../utils/savedItems';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';

var config = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: sessionStorage.getItem('loged_In_auth'),
  },
};

// Fallback images in case API doesn't return any
const defaultImages = [
  {
    original: 'assets/images/user/car-dealers/a.jpg',
    thumbnail: 'assets/images/user/car-dealers/a.jpg',
  },
  {
    original: 'assets/images/user/car-dealers/b.jpg',
    thumbnail: 'assets/images/user/car-dealers/b.jpg',
  },
];

// Rental rates are expressed per day. Stored period values like "1/day" should
// render as "1 Day" (client request, 2026-06-11). Numbers pass through; only the
// "/day" suffix is normalised so "7/day" -> "7 Day".
// Format a rental period like "1/day" into "1 <dayLabel>". dayLabel is passed
// in (t('Day')) so it localizes — e.g. "1 يوم" in Arabic. Defaults to 'Day'.
export const formatRentalPeriod = (time, dayLabel = 'Day') => {
  const s = String(time || '').trim();
  if (!s) return '';
  return s
    .replace(/\s*\/\s*day\b/i, ' ' + dayLabel)
    .replace(/\s+/g, ' ')
    .trim();
};

export default function RentCarDetailsIn() {
  // [CF] Lets a tap on the banner open the gallery full-screen.
  const galleryRef = useRef(null);
  var DetailList = useSelector((state) => state.home)?.getDetailList;

  const { t, i18n } = useTranslation();
  const isRTL = (i18n.language || 'en').toLowerCase().startsWith('ar');
  // English in English mode, Arabic in Arabic mode (fallback to whichever exists).
  const L = (en, ar) => (isRTL ? ar || en : en || ar);

  const dispatch = useDispatch();
  const { carId } = useParams();
  console.log('DetailListDetailList', DetailList, carId);

  const [carDetails, setCarDetails] = useState(null);
  const savedItemsList = useSelector((state) => state?.home?.savedItemsList);
  // Fill the heart when the car is already saved (or once the user saves it).
  const [saved, setSaved] = useState(false);
  useEffect(() => {
    if (carDetails) setSaved(!!carDetails.is_saved);
  }, [carDetails?.carId, carDetails?.is_saved]);
  useEffect(() => {
    dispatch(getSavedItems());
  }, [dispatch]);

  useEffect(() => {
    const fetchDetail = async (data) => {
      try {
        axios

          .get(
            `https://api.carsavenue.com/api/carRent/car?carId=${carId}`,

            config
          )

          .then((res) => {
            console.log('heeee<<<<', res);
            dispatch({
              type: DETAIL_LIST,
              payload: res.data.response?.data,
            });

            setCarDetails(res.data.response?.data?.[0]);
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (err) {}
    };
    if (carId && carId !== '') {
      fetchDetail({ carId });
      // Track this car as recently viewed
      dispatch(addToRecentlyViewed({ carId: carId, type: 'CAR04' }));
    }
  }, [carId, dispatch]);

  // useEffect(() => {
  //     if (DetailList && DetailList.length > 0 && carId) {
  //       const targetCar = DetailList.find((car) => car.carId === carId);
  //       if (targetCar) {
  //         setCarDetails(targetCar);
  //         setLoading(false);
  //       }
  //     }
  //   }, [allCars, carId]);
  console.log('carDetails', carDetails);

  // Process images for the gallery.
  // While the car is still loading (carDetails === null) keep this EMPTY so we
  // don't flash the hardcoded sample cars before the real images arrive. Only
  // fall back to defaultImages once the car has loaded but genuinely has none.
  let galleryImages = [];

  if (carDetails) {
    const mediaImages = (carDetails.carMedia || [])
      .filter(
        (mediaItem) =>
          // Accept all the car-image type spellings actually saved by the
          // add/edit forms (CAR_IMAGE) and legacy data (CAR_IMAGES / CAR-IMAGES).
          mediaItem?.media?.path &&
          [
            'CAR_IMAGE',
            'CAR_IMAGES',
            'CAR-IMAGES',
            'CAR-IMAGE',
            'IMAGES',
          ].includes(mediaItem.mediaType)
      )
      .map((mediaItem) => ({
        original: mediaItem.media.path,
        thumbnail: mediaItem.media.path,
      }));

    galleryImages = mediaImages.length > 0 ? mediaImages : defaultImages;
  }

  //POST TIME
  const formatPostedDate = (dateString) => {
    const date = moment(dateString);
    const now = moment();

    if (date.isSame(now, 'day')) {
      return 'Posted Today';
    } else if (date.isSame(now.clone().subtract(1, 'days'), 'day')) {
      return 'Posted Yesterday';
    } else {
      // [CF] Client: show the DATE only, no time.
      return `Posted on ${date.format('MMM D, YYYY')}`;
    }
  };

  const onHandleSave = () => {
    // Check if user is logged in
    const isLoggedIn = sessionStorage.getItem('loged_In') === 'true';
    
    if (!isLoggedIn) {
      Swal.fire({
        title: 'Please Login to Save',
        text: 'You need to be logged in to save this car. Please login first.',
        icon: 'warning',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Login',
        showCancelButton: true,
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          // Redirect to login page
          window.location.href = '#/login';
        }
      });
      return;
    }

    // User is logged in — optimistic toggle, no reload.
    // Must send the car's own carId (FK savedItems.rentalCarId -> rentalCars.carId),
    // NOT carRentId which is the business/listing id.
    const id = carDetails?.carId || carId;
    if (saved) {
      setSaved(false);
      const savedItemId =
        carDetails?.savedItemId || findSavedItemId(savedItemsList, id);
      if (savedItemId) dispatch(removeSavedItem({ savedItemId }));
    } else {
      setSaved(true);
      dispatch(saveAItem({ carRentalId: id }));
    }
  };

  const onHandleShare = (e) => {
    if (e) e.preventDefault();
    const url = window.location.href;
    const title = carDetails?.carName || 'CarsAvenue';
    if (navigator.share) {
      navigator.share({ title, url }).catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard
        .writeText(url)
        .then(() => Swal.fire({ title: 'Link copied to clipboard', icon: 'success' }))
        .catch(() => Swal.fire({ title: 'Copy this link', text: url, icon: 'info' }));
    } else {
      Swal.fire({ title: 'Copy this link', text: url, icon: 'info' });
    }
  };

  return (
    <div>
      {DetailList !== undefined ? (
        <>
          <div className="main-content-area">
            <div className="container">
              {/* [CF] mb-5 (48px) left a large empty band before the
                Specifications section — trimmed to mb-3. */}
          <div className="row mb-3">
                <div className="col-12 col-sm-12 col-md-6 col-lg-7 mb-2 mb-sm-2 mb-md-2 mb-lg-0">
                  <div className="bxslider cav-car-gallery">
                    {galleryImages.length > 0 ? (
                      <ImageGallery
                        ref={galleryRef}
                        items={galleryImages}
                        className="img-fluid"
                        infinite={true}
                        showNav={false}
                        showFullscreenButton={false}
                        // [CF] Client: tapping the banner opens the full view.
                        onClick={() => galleryRef.current?.fullScreen()}
                        useBrowserFullscreen={false}
                        showPlayButton={false}
                        showBullets={true}
                        slideInterval={3000}
                      />
                    ) : (
                      // Loading placeholder — avoids flashing sample images.
                      <div
                        style={{
                          width: '100%',
                          aspectRatio: '4 / 3',
                          background: '#f2f2f2',
                          borderRadius: '8px',
                        }}
                      />
                    )}
                  </div>
                </div>

                <div className="col-12 col-sm-12 col-md-6 col-lg-5 d-flex align-items-start">
                  <div className="w-100">
                    {/* [CF] Posted date and Save/Share share ONE row (client:
                        move share and save up). Matches the other detail pages. */}
                    <div
                      className="mb-2"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        // [CF 2026-08-02] Save/Share must sit on the LEFT and the posted date
                        // on the RIGHT in BOTH languages. `space-between` alone mirrors with
                        // the page, so in Arabic they swapped sides; row-reverse in RTL flips
                        // the main axis back so the physical placement is language-independent.
                        flexDirection: isRTL ? 'row-reverse' : 'row',
                        gap: '16px',
                        flexWrap: 'wrap',
                      }}
                    >
                      <div
                        className="save-share"
                        style={{ display: 'flex', alignItems: 'center', gap: '18px', flexShrink: 0 }}
                      >
                        <span onClick={onHandleSave} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                          <i
                            className={saved ? 'fas fa-heart' : 'far fa-heart'}
                            style={{ color: saved ? '#FEBA00' : 'inherit' }}
                          ></i>{' '}
                          {t('Save')}
                        </span>
                        <span onClick={onHandleShare} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                          <i className="far fa-share-square"></i> {t('Share')}
                        </span>
                      </div>
                      <p className="mb-0" style={{ textAlign: isRTL ? 'right' : 'left' }}>
                        <small>
                          <i className="far fa-calendar-alt"></i>{' '}
                          {carDetails?.createdAt &&
                            formatPostedDate(carDetails.createdAt)}
                        </small>
                      </p>
                    </div>

                    {/* [CF] Brand and model on ONE line; price follows below. */}
                    <div
                      className="mb-2"
                      style={{
                        display: 'flex',
                        alignItems: 'baseline',
                        justifyContent: 'space-between',
                        gap: '16px',
                        flexWrap: 'wrap',
                      }}
                    >
                      <h3 className="mb-0" style={{ textAlign: isRTL ? 'right' : 'left' }}>
                        {L(
                          carDetails?.brand?.name,
                          carDetails?.brand?.nameAr
                        ) ||
                          carDetails?.carName ||
                          carDetails?.carRentName ||
                          ''}
                      </h3>
                      <p className="mb-0" style={{ textAlign: isRTL ? 'right' : 'left' }}>
                        {[
                          carDetails?.carModel,
                          carDetails?.modelYear?.modelYear,
                        ]
                          .filter(Boolean)
                          .join(' ')}
                      </p>
                    </div>

                    <div className="cav-car-desc">
                      {(
                        carDetails?.description ||
                        'No description available for this vehicle.'
                      )
                        .split(/\r?\n|(?=✅)|(?=✔️)|(?=✈️)|(?=•)/)
                        .map((line) => line.trim())
                        .filter(Boolean)
                        .map((line, idx) => (
                          <div className="cav-car-desc-line" key={idx}>
                            {line}
                          </div>
                        ))}
                    </div>

                    <div className="cav-price-wrap">
                      <div className="row">
                        <div className="col-12">
                          <div className="cav-price-card">
                            <div className="cav-price-head">
                              {t('Rental Rates')}
                            </div>
                            {/* Column labels: Rental Period (day count) / Rental Cost (price) */}
                            <div className="cav-price-row">
                              {/* [CF] Both header titles share one identical font
                                  (the Cost cell was inheriting the green/bold
                                  price style, making the two titles mismatch). */}
                              <span
                                className="cav-price-period"
                                style={{
                                  fontWeight: 700,
                                  fontSize: '1rem',
                                  color: 'inherit',
                                }}
                              >
                                {t('Period')}
                              </span>
                              <span
                                className="cav-price-amount"
                                style={{
                                  fontWeight: 700,
                                  fontSize: '1rem',
                                  color: 'inherit',
                                }}
                              >
                                {t('Cost')}
                              </span>
                            </div>
                            {carDetails?.packages?.map((pkg, i) => (
                              <div className="cav-price-row" key={i}>
                                <span className="cav-price-period">
                                  {formatRentalPeriod(pkg?.time, t('Day'))}
                                </span>
                                <span className="cav-price-amount">
                                  {pkg?.starting_price || ''}{' '}
                                  {(pkg?.currency || '').toUpperCase()}
                                </span>
                              </div>
                            ))}
                          </div>
                        </div>
                        {/* <div className='col-12'>
															<div className='car-details-block-horizontal'>
																<div className='row'>
																	<div className='col-4'>
																		<div className='line-a'>15 Days</div>
																	</div>
																	<div className='col-8'>
																		<div className='line-b'>KWD 130.000</div>
																	</div>
																</div>
															</div>
														</div>
														<div className='col-12'>
															<div className='car-details-block-horizontal'>
																<div className='row'>
																	<div className='col-4'>
																		<div className='line-a'>1 Month</div>
																	</div>
																	<div className='col-8'>
																		<div className='line-b'>KWD 250.000</div>
																	</div>
																</div>
															</div>
														</div> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-7 col-lg-7">
                    <div
                      style={{
                        display: 'flex',
                        gap: '1rem',
                        flexWrap: 'wrap',
                      }}
                    >
                      {carDetails?.businessMedia?.map((it) => (
                        <img
                          alt=""
                          style={{
                            width: '10rem',
                            height: '10rem',
                            borderRadius: '10px',
                          }}
                          src={it?.media?.path}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          {/* <h2>dsdasdfasdf</h2> */}
          <div
            className="text-center text-warning"
            const
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          >
            <PageLoader /> <br />
          </div>
        </>
      )}
    </div>
  );
}
